import { render, staticRenderFns } from "./employeeHeader.vue?vue&type=template&id=24822e6a&scoped=true"
import script from "./employeeHeader.vue?vue&type=script&lang=js"
export * from "./employeeHeader.vue?vue&type=script&lang=js"
import style0 from "./employeeHeader.vue?vue&type=style&index=0&id=24822e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24822e6a",
  null
  
)

export default component.exports